export default {
    contactUsStatus: false,
    error: {
        show: false,
        message: ''
    }
}



// WEBPACK FOOTER //
// ./src/store/contactus/state.js